import { DomainScopes } from "../../constants/DomainConstants";
import GetCustomAction from "./CustomNavActions";

const tabTypes = [
    {
        typeId: 121450000,
        title: "type1",
        tabNumber: 0
    },
    {
        typeId: 121450001,
        title: "type2",
        tabNumber: 1
    },
    {
        typeId: 121450002,
        title: "Adressen",
        tabNumber: 2
    }
];

export function GetTopNavItems(topNavTabSettings, scope, transactionId) {
    let items;
    switch (scope) {
        case DomainScopes.FEDERATIE:
            items = getFederatieTopNavItems(topNavTabSettings, transactionId);
            break;
        case DomainScopes.NIEUWESPORTCLUB:
            items = getNieuweSportclubTopNavItems(topNavTabSettings);
            break;
        case DomainScopes.SPORTORGANISATIE:
            items = getFederatieTopNavItems(topNavTabSettings, transactionId);
            break;
        case DomainScopes.LOGIN:
            items = getNieuweSportclubTopNavItems(topNavTabSettings);
            break;
        default:
            items = getFederatieTopNavItems(topNavTabSettings, transactionId);
            break;
    }

    return items;
}

function getNieuweSportclubTopNavItems(topNavTabSettings) {
    return Object.keys(topNavTabSettings).map(key => {
        const tabSettings = topNavTabSettings[key];
        return {
            text: tabSettings.text,
            to: tabSettings.to,
            iconType: tabSettings.iconType,
            color: tabSettings.color,
            disabled: tabSettings.disabled,
            visible: tabSettings.visible,
            hideText: true,
            showBead: tabSettings.showBead,
            customNavAction: null,
            tabNr: tabSettings.tabNr,
            showAsSideNav: tabSettings.showAsSideNav,
            backToOverview: tabSettings.backToOverview
        };
    });
}

function getFederatieTopNavItems(topNavTabSettings, transactionId) {
    return Object.keys(topNavTabSettings).map(key => {
        const tabSettings = topNavTabSettings[key];
        return {
            text: tabSettings.text,
            to: tabSettings.backToOverview ? "/" + tabSettings.to + "/" : "/" + tabSettings.to + transactionId + "/",
            iconType: tabSettings.iconType,
            color: tabSettings.color,
            disabled: tabSettings.disabled,
            visible: tabSettings.visible,
            hideText: true,
            showBead: tabSettings.showBead,
            customNavAction: tabSettings.customNavAction ? GetCustomAction(tabSettings.customNavAction, transactionId) : null,
            tabNr: tabSettings.tabNr,
            showAsSideNav: tabSettings.showAsSideNav,
            backToOverview: tabSettings.backToOverview
        };
    });
}

export function getHeaderItems(topNavTabSettings, transactionId) {
    return Object.keys(topNavTabSettings).map(key => {
        const tabSettings = topNavTabSettings[key];
        return {
            text: tabSettings.text,
            to: tabSettings.backToOverview ? "/" + tabSettings.urlSuffix + "/" : "/" + tabSettings.urlSuffix + transactionId + "/",
            iconType: tabSettings.iconType,
            color: tabSettings.color,
            disabled: tabSettings.disabled,
            visible: tabSettings.visible,
            hideText: true,
            showBead: tabSettings.showBead,
            customNavAction: tabSettings.customNavAction ? GetCustomAction(tabSettings.customNavAction, transactionId) : null,
            tooltipText: tabSettings.tooltipText,
            showAsSideNav: tabSettings.showAsSideNav,
            backToOverview: tabSettings.backToOverview
        };
    });
}

export function formatValidatieStatussesForBeads(validatieStatusses) {
    return validatieStatusses.map(v => {
        const tabType = tabTypes.find(x => x.typeId == v.entiteitType);
        return {
            tab: tabType ? tabType.tabNumber : null,
            volledig: v.volledig,
            title: v.titel || (tabType ? tabType.title : null)
        };
    });
}

export function formatValidatieStatussesForSideNav(validatieStatusses) {
    const sideNavValidatieStatusses = validatieStatusses.filter(v => v.entiteitType == tabTypes[2].typeId).sort(v => v.titel);
    return sideNavValidatieStatusses.map(v => {
        return {
            url: "/sidenaventity/" + v.tochtGuid + "/" + v.entiteitGuid,
            display: v.titel,
            linkEnabled: true,
            lusId: v.entiteitGuid
        };
    });
}